import { updateDailyJobTicketLabor } from '../../../graphql/custom_mutations';
import PropTypes from 'prop-types';
import { generateClient } from 'aws-amplify/api';

const client = generateClient();

export const updateDailyJobTicketAttachedLabor = async (params) => {
  if (!params) return;

  try {
    const response = await client.graphql({
      query: updateDailyJobTicketLabor,
      variables: { input: params },
    });

    const results = response.data.updateSpkDJTLaborTbl.id;
    return results;
  } catch (err) {
    return ('error updateDailyJobTicketAttachedLabor: ', [err]);
  }
};

updateDailyJobTicketAttachedLabor.propTypes = {
  params: PropTypes.object.isRequired,
};
